import { render, staticRenderFns } from "./FormSelectSingle.vue?vue&type=template&id=2d6faa52&scoped=true&"
import script from "./FormSelectSingle.vue?vue&type=script&lang=js&"
export * from "./FormSelectSingle.vue?vue&type=script&lang=js&"
import style0 from "./FormSelectSingle.vue?vue&type=style&index=0&id=2d6faa52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6faa52",
  null
  
)

export default component.exports